import React, { Component } from 'react';
import { Debounce } from 'react-throttle';

import '../../../css/ScrobbleFilter.css';
import '../../../css/SearchBar.css';

class ScrobbleFilter extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      match: props.match
    }

    this.onChange = (query) => {
      this.setState(query); 
      props.onChange(query);
    };

  }

  componentDidMount() {
    if (this.refs.searchValue && this.refs.searchValue !== this.state.match) {
      this.refs.searchValue.value = this.state.match;
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      match: newProps.match
    });
  }

  currentQuery() {
    return {
      match: this.state.match
    }; 
  }

  search(evt) {
    evt.preventDefault();
    let match = evt.target.value;
    let query = this.currentQuery();
    query.match = match.trim().toLowerCase();
    this.onChange(query);
  }

  render() {
    
    return (

      <div>

        <Debounce time="300" handler="onChange">
          <input type="text" ref="searchValue" onChange={this.search.bind(this)} className="searchBar" placeholder="Search"/>        
        </Debounce>

    </div>
  );

  }

}

export default ScrobbleFilter;



// WEBPACK FOOTER //
// ./src/js/components/filter/ScrobbleFilter.jsx